<template>
  <div :class="computedClass">
    <v-btn
    elevation="2"
    :href="generateLinkDownload(value)"
    >
    {{this.$i18n.t('fatura')}}
    </v-btn>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'DataTableTransformLinkColumn',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          shouldWrap: false,
        }
      },
    },
  },
  computed: {
    computedClass() {
      return {
        noWrap: !this.options.shouldWrap,
      }
    },
  },
  methods: {
    generateLinkDownload(value){
        return config.VUE_APP_API_URL + value;
    }
  }
}
</script>
